/* ── Pipeline View Types ─────────────────────────────────── */

/** Represents a source table */
export interface PipelineSourceTable {
  alias: string;
  columnCount?: number;
}

/** Represents a join node in the pipeline */
export interface PipelineJoinNode {
  id: string;
  joinType: string;
  leftTable: string;
  rightTable: string;
  condition: string;
}

/** A single mapping step within a target */
export interface PipelineStep {
  stepId: string;
  operation: string;
  description: string;
  inputs: string[];
  outputs: string[];
  expression?: string;
  confidence: number;
}

/** A target table and its transformation steps */
export interface PipelineTargetTable {
  name: string;
  description: string;
  stepCount: number;
  directCount: number;
  expressionCount: number;
  steps: PipelineStep[];
  avgConfidence: number;
  /** Which source tables feed this target (derived from step inputs) */
  sourceTables: string[];
}

/** A directed edge from a source to a target */
export interface PipelineEdge {
  from: string;   // source alias
  to: string;     // target table name
}

/** Complete pipeline model */
export interface PipelineModel {
  sources: PipelineSourceTable[];
  joins: PipelineJoinNode[];
  targets: PipelineTargetTable[];
  edges: PipelineEdge[];
}

/* ── Color constants ─────────────────────────────────────── */

export const SOURCE_COLOR = '#3b82f6';
export const JOIN_COLOR = '#8b5cf6';
export const TARGET_COLOR = '#22c55e';
export const EXPR_COLOR = '#ec4899';
export const DIRECT_COLOR = '#64748b';
